import MatchedMap from 'utilities/src/matchedMap';
import { HeaderSizesEnum } from '../types/_size';

const headerContainerClasses = 'relative box-content flex h-full items-center justify-between px-8 xl:mx-auto';
const headerLogoLinkClasses = 'block h-[22px]';
const headerNavClasses = 'flex h-full items-center';
const headerNavContainerClasses = '';

const headerSizesClasses = new MatchedMap([
  [HeaderSizesEnum.Small, 'h-12'],
  [HeaderSizesEnum.Medium, 'h-20 mb-10'],
]);

const headerCommonTheme = {
  headerContainerClasses,
  headerLogoLinkClasses,
  headerNavClasses,
  headerNavContainerClasses,
  headerSizesClasses,
};

export default headerCommonTheme;
